class PlpEmpty extends HTMLElement {
  connectedCallback() {
    this.swiperEl = this.querySelector('.plp-empty__swiper');
    if (this.swiperEl) this.initSwiper();
    this.initTouchHover();
  }

  initTouchHover() {
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isDesktop) return;

    const slides = this.querySelectorAll('.plp-empty__slide.slide-has-hover-img');
    const HOLD_MS = 150;
    let pressTimer = null;

    slides.forEach(slide => {
      const media = slide.querySelector('.plp-empty__media');
      if (!media) return;

      media.addEventListener('touchstart', (e) => {
        slides.forEach(s => s.classList.remove('touch-active'));
        pressTimer = setTimeout(() => {
          slides.forEach(s => s.classList.remove('touch-active'));
          slide.classList.add('touch-active');
        }, HOLD_MS);
      }, { passive: true });

      media.addEventListener('touchmove', () => {
        clearTimeout(pressTimer);
      }, { passive: true });

      media.addEventListener('touchend', () => {
        clearTimeout(pressTimer);
      }, { passive: true });
    });

    document.addEventListener('touchstart', () => {
      slides.forEach(s => s.classList.remove('touch-active'));
    }, { passive: true });
  }

  initSwiper() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      // Swiper's JS touch handling fights the page's native scroll on Android;
      // below the phone breakpoint, skip Swiper entirely and let the browser
      // scroll the rail natively instead.
      this.swiperEl.classList.add('plp-empty__swiper--native-scroll');
      return;
    }

    this.swiper = new Swiper(this.swiperEl, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 1.93,
      simulateTouch: true,
      threshold: 0,
      touchAngle: 70,
      freeMode: {
        enabled: true,
        sticky: false,
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 2,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) this.swiper.destroy(true, true);
  }
}

customElements.define('plp-empty', PlpEmpty);
